// ═══════════════════════════════════════════════════════════════
//  interventionsLecture.js — lecture de la liste des interventions
//
//  Isolé d'interventionsDonnees (Storage, callable) pour que l'accueil
//  (HomePage) fasse EXACTEMENT les mêmes requêtes que la liste sans charger
//  le reste du module.
//
//  Contrat de requête (règle `read` du match /interventions) :
//   • superviseur (Admin, Direction, Assistante) : requête nue ;
//   • tout autre rôle : DEUX requêtes — `accesUids array-contains <uid>`
//     et `ouverte == true` — union dédupliquée par id côté client. Une
//     requête nue d'un non-superviseur est refusée par la règle.
//  🔴 PERF-1 : getDocs PONCTUELS, pas d'onSnapshot, pas d'orderBy (tri
//  client), plafond 500 par requête et au total + `tronque`.
// ═══════════════════════════════════════════════════════════════
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "../../firebase";
import { estSuperviseur } from "./interventionsModel";

export const PLAFOND_LECTURE = 500;
const COL = "interventions";

// → { interventions, tronque }
export async function listerInterventions({ role, uid }) {
  const base = collection(db, COL);
  const requetes = estSuperviseur(role)
    ? [query(base, limit(PLAFOND_LECTURE + 1))]
    : [
      query(base, where("accesUids", "array-contains", uid || "-"), limit(PLAFOND_LECTURE + 1)),
      query(base, where("ouverte", "==", true), limit(PLAFOND_LECTURE + 1)),
    ];
  const snaps = await Promise.all(requetes.map((q) => getDocs(q)));
  let tronque = false;
  const parId = new Map();
  for (const snap of snaps) {
    if (snap.docs.length > PLAFOND_LECTURE) tronque = true;
    for (const d of snap.docs.slice(0, PLAFOND_LECTURE)) if (!parId.has(d.id)) parId.set(d.id, { id: d.id, ...d.data() });
  }
  const docs = [...parId.values()];
  return { interventions: docs.slice(0, PLAFOND_LECTURE), tronque: tronque || docs.length > PLAFOND_LECTURE };
}
